var React = require('react');

function IndustryPurpleLineInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"m3.25 115.5.5-115.5","opacity":".27274","stroke":"#fff","strokeLinecap":"square","key":0}),React.createElement("circle",{"cx":"3","cy":"115","fill":"#b070fd","r":"3","key":1})]));
}

IndustryPurpleLineInline.defaultProps = {"height":"118","viewBox":"0 0 6 118","width":"6"};

module.exports = IndustryPurpleLineInline;

IndustryPurpleLineInline.default = IndustryPurpleLineInline;
